module.exports = __webpack_public_path__ + "d54f84c2adc8069c174d8679aaefec2c.png";